export default __webpack_public_path__ + "static/media/portal.bd81ef30.png";